
import { defineComponent } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'

export default defineComponent({
  components: { NeueLoading },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    listLength: {
      type: Number,
      required: true
    },
    emptyStateHeading: {
      type: String,
      required: false,
      default: 'No items yet'
    },
    emptyStateDescription: {
      type: String,
      required: false,
      default: "Get started by clicking 'New'"
    }
  }
})
